import { useEffect, useState } from 'react';
import { getBackground, editBackground } from 'api/newUniprofile';
import { IBackgroundInfo, INewUniprofileResume } from 'types/newUniprofile';
import { message } from 'antd';
import { getUrlParam } from 'utils/common';
import uniprofileResumeStore from 'store/UniprofileResume';

const DefaultBackgroundInfo: IBackgroundInfo = {
    providerExperienceList: [],
    providerEducationList: [],
    associationRecognitionList: [],
    awardRecognitionList: [],
    publicationRecognitionList: [],
    treatmentPhilosophy: '',
    biographic: {
        ethnicity: '',
        birthDate: '',
        religion: '',
        usedName: '',
    },
};

export const useBackgroundInfo = (): [IBackgroundInfo, boolean, () => void, (data: Partial<IBackgroundInfo>) => Promise<void>] => {
    const [loading, setLoading] = useState(false);
    const [serviceData, setServiceData] = useState<IBackgroundInfo>(DefaultBackgroundInfo);
    const isAva = getUrlParam('isAva') === 'true';
    const [getResumeInfo] = uniprofileResumeStore.useStore();

    const getResumeData = () => {
        const resumeData = getResumeInfo('data') as INewUniprofileResume;
        if (resumeData?.backGround) {
            setServiceData(resumeData.backGround);
        }
    };

    const fetchData = async () => {
        try {
            setLoading(true);
            const result = await getBackground();
            if (!result.error) {
                const data: IBackgroundInfo = result?.data?.data || DefaultBackgroundInfo;
                setServiceData(data);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        if (isAva) {
            getResumeData();
        } else {
            fetchData();
        }
    }, []);

    useEffect(() => {
        if (isAva) {
            getResumeData();
        }
    }, [getResumeInfo('data')]);

    const updateBackgroundInfo = async (data: Partial<IBackgroundInfo>) => {
        try {
            setLoading(true);
            const result = await editBackground({
                ...serviceData,
                ...data,
            });
            if (result.error) {
                message.error(result.message);
            } else {
                message.success('Update successfully');
                fetchData();
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };
    return [serviceData, loading, fetchData, updateBackgroundInfo];
};
